import {Injectable} from '@angular/core';
import {CanActivate, CanLoad} from '@angular/router';
import {AuthenticationService} from '@synisys/idm-authentication-client-js';
import 'rxjs/add/operator/take';
import {ensureKendo} from './ensure-kendo';
import {take} from 'rxjs/operators';

@Injectable()
export class KendoLoadGuard implements CanLoad, CanActivate {

	constructor(private authenticationService: AuthenticationService) {
	}

	public canLoad(): boolean {
		this.authenticationService.isLoggedOn().pipe(take(1)).subscribe(isLogged => {
			if (isLogged) {
				ensureKendo().catch(() => undefined);   // failures surface in canActivate, which retries
			}
		});
		return true;
	}

	public canActivate(): Promise<boolean> {
		return ensureKendo().then(
			() => true,
			error => {
				console.error('Failed to load Kendo UI', error);
				return true;   // don't lock the user out of the whole app; only Kendo widgets will fail
			}
		);
	}
}
